<script>
  import VueSwiper from "./VueSwiper.vue";
  import eventBus from "./EventBus.vue";

  export default {
    name: 'modalYoutube',
    data: function () {
      return {
      }
    },
    props: {
      item: {
        type: Object,
        default: function (){
          return {}
        }
      }
    },
    methods: {
      close(event) {
        this.$emit('close', event);
      },
    },
    computed: {
      /*youtubes() {
        console.log(this.item);
        let result = [];
        if (this.item.youtube_id.length > 0) {
            result.push(this.item.youtube_id);
        }

        return result;
      }*/
    },
    components: {
      VueSwiper
    }
  };
</script>
<template>
  <transition name="modal">
    <div class="modal-mask" v-if="item.name">
      <div class="modal-wrapper" @click="close($event)">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Видео</h3>
            <button type="button" class="btn-close-modal" @click="close()">×</button>
          </div>

          <div class="modal-body">
            <div class="youtube-modal-box" v-if="item.youtube_id">
              <iframe width="800" height="500" :src="'https://www.youtube.com/embed/' + item.youtube_id + '?autoplay=1'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
          </div>

          <div class="modal-footer">
            <a class="modal-default-button" @click="close()">
              Закрыть
            </a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<style scoped>
  .modal-container {
    width: 70%;
  }
  .youtube-modal-box{
    margin: auto;
    padding: 10px;
    width: 820px;
  }
</style>